module.exports = {
    //Common Button
    "TNF_BTN_SEARCH": "ค้นหา",
    "TNF_BTN_CLEAR": "ล้างข้อมูล",
    "TNF_BTN_ADD": "เพิ่ม",

    "TNF_ACTIVE": "ใช้งาน",
    "TNF_INACTIVE": "ไม่ใช้งาน",

    "TNF_VALIDATION_WARNING_HEADER" : "กรุณาระบุข้อมูลให้ครบถ้วนในการยื่นข้อเทียบโอน",
    // "TNF_VALIDATION_WARNING_LEFT_SUBJECT" : "กรุณาระบุข้อมูลให้ครบถ้วนในการยื่นข้อเทียบโอน",
    // "TNF_VALIDATION_WARNING_RIGHT_SUBJECT" : "กรุณาระบุข้อมูลให้ครบถ้วนในการยื่นข้อเทียบโอน",
    // "TNF_VALIDATION_WARNING_COURSE_SYLLABUS" : "กรุณาระบุข้อมูลให้ครบถ้วนในการยื่นข้อเทียบโอน",
    // "TNF_VALIDATION_WARNING_HEADER_" : "กรุณาระบุข้อมูลให้ครบถ้วนในการยื่นข้อเทียบโอน",
    // "TNF_VALIDATION_WARNING_HEADER" : "กรุณาระบุข้อมูลให้ครบถ้วนในการยื่นข้อเทียบโอน",
    'TNF_NO_COPEN' : 'ไม่มีแผนที่รับนิสิต'
}
